import { fetcher } from "helpers/fetcher";

import { TUpdateAccessReq, TUpdateAccessRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateEmployeeAccess = async (payload: TUpdateAccessReq) => {
  return await fetcher<TUpdateAccessRes, TUpdateAccessReq["data"]>(
    ENDPOINT.BU.UPDATE_EMPLOYEE_ACCESS,
    {
      data: payload.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.BU.UPDATE_EMPLOYEE_ACCESS.version,
        [API_HEADER.USER_ID]: payload.idUser,
        [API_HEADER.BU_ID]: payload.idBu,
      },
    }
  );
};

export const mutationUpdateEmployeeAccess = async (
  payload: TUpdateAccessReq
) => {
  return (await updateEmployeeAccess(payload)).data;
};

mutationUpdateEmployeeAccess._key = (payload: TUpdateAccessReq) => [
  ENDPOINT.BU.UPDATE_EMPLOYEE_ACCESS.url,
  payload,
];
